<template>
  <div class="render-in-view-container">
    <!-- Use v-if to render content only when 'isVisible' is true -->
    <div v-if="isVisible" class="content">
      <!-- Your heavy content or component goes here -->
      <slot></slot>
    </div>
    
    <!-- A "sentinel" div to attach the Intersection Observer to -->
    <div v-else ref="sentinel" class="sentinel">
      <!-- Optional: a loading spinner or placeholder can go here -->
      Loading content...
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
      observer: null
    };
  },
  mounted() {
    // Create an Intersection Observer to watch the sentinel element
    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting) {
          this.isVisible = true;
          // Stop observing once it's visible, as we only need to render once
          this.observer.disconnect();
        }
      },
      {
        root: null, // observe within the viewport
        threshold: 0.1 // trigger when 10% of the sentinel is visible
      }
    );

    // Start observing the sentinel element reference
    if (this.$refs.sentinel) {
      this.observer.observe(this.$refs.sentinel);
    }
  },
  beforeDestroy() {
    // Clean up the observer when the component is destroyed
    if (this.observer) {
      this.observer.disconnect();
    }
  }
};
</script>

<style scoped>
.sentinel {
  /* Give the sentinel some height so the observer can track it properly */
  min-height: 10px; 
  text-align: center;
  padding: 3px;
  border: 1px dashed #ccc;
}
</style>